import { Drawer } from '@mantine/core';
import type { ReactNode } from 'react';

export interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  height?: number | string;
}

export function BottomSheet({ open, onClose, title, footer, children, height = 'auto' }: BottomSheetProps) {
  return (
    <Drawer
      opened={open}
      onClose={onClose}
      position="bottom"
      size={height === 'auto' ? '75%' : height}
      withCloseButton={false}
      padding={0}
      overlayProps={{ color: 'rgba(28,25,23,0.45)', backgroundOpacity: 1 }}
      styles={{
        content: {
          background: 'var(--surface-overlay)',
          borderTopLeftRadius: 18,
          borderTopRightRadius: 18,
          boxShadow: 'var(--shadow-lg)',
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '88%',
        },
        body: { display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, padding: 0 },
      }}
    >
      <div style={{ padding: '8px 0 4px', display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: 36, height: 4, borderRadius: 999, background: 'var(--border-strong)' }} />
      </div>
      {title && (
        <div
          style={{
            padding: '8px 18px 4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {/* Drawer.Title (not a plain span) is what gives the dialog its accessible name. */}
          <Drawer.Title component="span" style={{ fontWeight: 600, fontSize: 15, lineHeight: 'inherit' }}>{title}</Drawer.Title>
          <button
            onClick={onClose}
            aria-label="Close"
            style={{
              background: 'transparent',
              border: 0,
              width: 30,
              height: 30,
              borderRadius: 999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--text-secondary)',
              cursor: 'pointer',
            }}
          >
            ✕
          </button>
        </div>
      )}
      <div style={{ padding: 18, paddingTop: title ? 12 : 18, overflowY: 'auto', flex: 1, minHeight: 0 }}>
        {children}
      </div>
      {footer && (
        <div style={{ padding: '12px 16px 22px', borderTop: '1px solid var(--border-subtle)' }}>{footer}</div>
      )}
    </Drawer>
  );
}
